import { Component, OnInit, Renderer2 } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { User } from '@models/user/user';
import { SideNavService } from '../layout/side-nav/services/side-nav.service';
import { LogOutModalComponent } from '../login/log-out-modal/log-out-modal.component';
import { OrganizationService } from '../../areas/organization/organization.service';
import { BaseComponent } from '@app/base/basecomponent';
import { UpdateService } from '@app/_services/update.service';


@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html'
})
export class NavMenuComponent extends BaseComponent implements OnInit {

  public modalRef: BsModalRef;
  public currentUser: User;
  public bsModalRef: BsModalRef;
  public isOrgAdmin: boolean = false;

  constructor(
    private organizationService: OrganizationService,
    private modalService: BsModalService,
    private updateService: UpdateService,
    private sideNavService: SideNavService
  ) {
    super();
  }

  ngOnInit() {
    this.subscription.add(this.authService.currentUser.subscribe(user => this.currentUser = user));
    this.subscription.add(this.organizationService.isUserOrganizationAdmin().subscribe(isOrgAdmin => {
      this.isOrgAdmin = isOrgAdmin;
      // Send isOrgAdmin value to side-navigation, since it also needs this information
      this.sideNavService.isOrgAdmin.next(isOrgAdmin);
    }, error => {
      this.isOrgAdmin = false;
      this.sideNavService.isOrgAdmin.next(false);
    }));
  }

  openLogOutModal() {
    this.bsModalRef = this.modalService.show(LogOutModalComponent);
  }

  toggleSideNavigation() {
    const value = this.sideNavigationCollapse();
    this.sideNavService.setCollapse(!value);
  }

  sideNavigationCollapse(): boolean {
    return this.sideNavService.getCollapseValue();
  }

}
